import { useState, useEffect } from "react";
import { generateClient } from "aws-amplify/data";
import { fetchAuthSession } from "aws-amplify/auth";

const client = generateClient();

export default function VisitCounter() {
  const [visitas, setVisitas] = useState(null);

  useEffect(() => {
    const incrementAndFetchVisitas = async () => {
      try {
        // Obtener el banner desde AppSync con el authMode adecuado
        // Obtener el valor actual del contador de visitas
        const { data: items } = await client.models.Parametro.list({
          filter: { clave: { eq: "visitas" } },
        });

        let currentVisitas;

        if (items.length > 0) {
          currentVisitas = items[0];
        } else {
          // Si no existe la clave "visitas", la creamos con un valor inicial de 0
          const { data: newVisitas } = await client.models.Parametro.create({
            clave: "visitas",
            valor: 0,
          });
          currentVisitas = newVisitas;
        }

        // Incrementar visitas en +1
        const { data: updatedVisitas } = await client.models.Parametro.update({
          id: currentVisitas.id,
          clave: "visitas",
          valor: Number(currentVisitas.valor) + 1,
        });

        // Actualizar el estado con el nuevo número de visitas
        setVisitas(updatedVisitas.valor);
      } catch (error) {
        console.error("Error al actualizar el contador de visitas:", error);
      }
    };

    incrementAndFetchVisitas();
  }, []);

  return (
    <div className="border-2 border-sky-500 bg-sky-400 pt-2 text-center text-xs text-sky-900">
      <div>© 2025 Educación en la fe. Todos los derechos reservados.</div>
      <strong>{`Este sitio ha sido visitado ${visitas} veces.`}</strong>
    </div>
  );
}
